/** @format */

export const namespaced = true;

export const state = {
	errors: {}
};

let nextId = 1;

export const mutations = {
	ADD(state, errors) {
		state.errors = errors;
	},
	RESET(state, notificationToRemove) {
		state.errors = {};
	}
};
export const getters = {
	errors(state) {
		return state.errors;
	}
};

export const actions = {
	addErrors({commit}, errors) {
		commit('ADD', errors);
	},
	reset({commit}) {
		commit('RESET');
	}
};
